import { isValidNumber } from 'libphonenumber-js';

export const validatePhoneNumber = (phone: string): boolean => isValidNumber(phone);
